import React from "react";
import "./Invoicing.scss";
import {
  Backdrop,
  Box,
  CircularProgress,
  createStyles,
  Tab,
  Theme,
  Typography
} from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import makeStyles from "@material-ui/core/styles/makeStyles";
import InvoicesList from "../InvoicesList";
import UninvoicedItems from "../UninvoicedItems";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    tabLabel: {
      fontSize: "0.9rem"
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    }
  })
);

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

const Invoicing = (props: any) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <div className={`${classes.root} Invoicing-container`}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab
          className={`${classes.tabLabel} Invoicing-invoicesAndCreditNotesTab`}
          label="Invoices & Credit Notes"
        />
        <Tab
          className={`${classes.tabLabel} Invoicing-uninvoicedItemsTab`}
          label="Uninvoiced Items"
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <InvoicesList
          invoices={props.invoices}
          paginationInfo={props.paginationInfo}
          onChangePageNumber={props.onChangePageNumber}
          onChangePageSize={props.onChangePageSize}
          onSort={(x: any) => props.onSort(x)}
          sortCriteria={props.sortCriteria}
        />
        {props.isInvoicesLoading && (
          <div>
            <Backdrop className={classes.backdrop} open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <UninvoicedItems
          items={props.uninvoicedItems}
          onCreateInvoice={props.onCreateInvoice}
          paginationInfo={props.uninvoicedPaginationInfo}
          onChangePageNumber={props.onChangeUninvoicedPageNumber}
          onChangePageSize={props.onChangeUninvoicedPageSize}
          onSort={(x: any) => props.onUninvoicedSort(x)}
          permissions={props.permissions}
        />
        {props.isUninvoicedItemsLoading && (
          <div>
            <Backdrop className={classes.backdrop} open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
        )}
      </TabPanel>
    </div>
  );
};

export default Invoicing;
